export function normalizarCanalNombre(canal) {
  return String(canal || "")
    .trim()
    .toLowerCase()
    .replace(/\s+/g, "_")
    .replace(/[^a-z0-9_áéíóúñ]/gi, "");
}

export function resolverCanalEnConfig(valor, canalesConfig = []) {
  const normalizado = normalizarCanalNombre(valor);
  if (!normalizado) return "";
  const existente = canalesConfig.find((c) => c.toLowerCase() === normalizado);
  return existente || normalizado;
}
